var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    fill: "#AAA",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128,234.667c35.355,0,64-28.645,64-64s-28.645-64-64-64s-64,28.645-64,64S92.645,234.667,128,234.667z M128,149.333 c11.791,0,21.333,9.542,21.333,21.333S139.791,192,128,192s-21.333-9.542-21.333-21.333S116.209,149.333,128,149.333z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M490.667,42.667H21.333C9.551,42.667,0,52.218,0,64v384c0,11.782,9.551,21.333,21.333,21.333h469.333 c11.782,0,21.333-9.551,21.333-21.333V64C512,52.218,502.449,42.667,490.667,42.667z M469.333,426.667H42.667V85.333h426.667 V426.667z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.582,377.752c8.331,8.331,21.839,8.331,30.17,0l91.582-91.582l48.915,48.915c8.331,8.331,21.839,8.331,30.17,0 s8.331-21.839,0-30.17l-9.555-9.555l41.373-68.954l66.013,66.013c8.331,8.331,21.839,8.331,30.17,0 c8.331-8.331,8.331-21.839,0-30.17l-85.333-85.333c-9.814-9.814-26.238-7.792-33.378,4.109l-49.942,83.237l-23.346-23.346 c-8.331-8.331-21.839-8.331-30.17,0L91.582,347.582C83.251,355.913,83.251,369.42,91.582,377.752z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload2);
export default __webpack_public_path__ + "static/media/upload2.cf654715ebbea1514293abff481ded3d.svg";
export { ForwardRef as ReactComponent };